/** 城市选择弹窗内容 当城市选择作为单独页面显示时使用**/
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useCallback, useEffect, memo } from 'react';
import smartScroll from '../../utils/smartScroll';
import { WithErrorHandler } from '../WithErrorHandler';
import { getStorageData, setStorageData } from '../../utils/dataStorage';
import { request } from '../../utils/request';
var smartScrollObj = {};
var cityListData = {
    热门城市: [
        '北京@@@613',
        '天津@@@615',
        '石家庄@@@6',
        '呼和浩特@@@48',
        '保定@@@10',
        '邯郸@@@8',
        '邢台@@@9',
        '沧州@@@14',
        '赤峰@@@51',
        '运城@@@637',
        '上海@@@611',
        '杭州@@@153',
        '无锡@@@132',
        '济宁@@@232',
        '烟台@@@231',
        '广州@@@347',
        '成都@@@386',
        '长沙@@@326',
        '武汉@@@291',
        '郑州@@@260',
        '重庆@@@539',
        '长春@@@85',
        '沈阳@@@63',
        '兰州@@@445',
        '临沂@@@568',
        '唐山@@@7',
        '青岛@@@226',
        '秦皇岛@@@13',
        '宁波@@@154',
        '大连@@@64',
        '太原@@@33',
        '合肥@@@181',
    ],
    A: [
        '\u5b89\u9633@@@267',
        '\u978d\u5c71@@@65',
        '\u963f\u62c9\u5584\u76df@@@635',
        '\u963f\u52d2\u6cf0@@@647',
        '\u963f\u514b\u82cf@@@470',
        '\u5b89\u5eb7@@@620',
        '\u963f\u91cc@@@970',
        '\u963f\u575d@@@651',
        '\u5b89\u5e86@@@188',
        '\u5b89\u987a@@@417',
    ],
    B: [
        '\u5317\u4eac@@@613',
        '\u6ee8\u6d77\u533a@@@623',
        '\u6ee8\u5dde@@@238',
        '\u4fdd\u5b9a@@@10',
        '\u767d\u57ce@@@92',
        '\u767d\u5c71@@@90',
        '\u672c\u6eaa@@@67',
        '\u5305\u5934@@@49',
        '\u5df4\u5f66\u6dd6\u5c14\u76df@@@634',
        '\u535a\u5c14\u5854\u62c9@@@646',
        '\u5df4\u97f3\u90ed\u695e@@@645',
        '\u767d\u94f6@@@448',
        '\u5b9d\u9e21@@@434',
        '\u5df4\u4e2d@@@410',
        '\u868c\u57e0@@@186',
        '\u4eb3\u5dde@@@679',
        '\u4fdd\u5c71@@@428',
        '\u6bd5\u8282@@@667',
        '\u5317\u6d77@@@371',
        '\u767e\u8272@@@670',
    ],
    C: [
        '\u91cd\u5e86@@@539',
        '\u6f6e\u5dde@@@664',
        '\u6ca7\u5dde@@@14',
        '\u627f\u5fb7@@@12',
        '\u957f\u6625@@@85',
        '\u671d\u9633@@@75',
        '\u8d64\u5cf0@@@51',
        '\u660c\u5409@@@804',
        '\u957f\u6cbb@@@36',
        '\u660c\u90fd@@@973',
        '\u6210\u90fd@@@386',
        '\u957f\u6c99@@@326',
        '\u90f4\u5dde@@@334',
        '\u5e38\u5fb7@@@332',
        '\u6c60\u5dde@@@677',
        '\u5de2\u6e56@@@192',
        '\u6ec1\u5dde@@@190',
        '\u5e38\u5dde@@@131',
        '\u695a\u96c4@@@424',
        '\u5d07\u5de6@@@672',
    ],
    D: [
        '\u4e1c\u8425@@@229',
        '\u5fb7\u5dde@@@580',
        '\u4e1c\u839e@@@354',
        '\u5927\u5e86@@@105',
        '\u5927\u5174\u5b89\u5cad@@@630',
        '\u5927\u8fde@@@64',
        '\u4e39\u4e1c@@@68',
        '\u5b9a\u897f@@@639',
        '\u5927\u540c@@@34',
        '\u5fb7\u9633@@@389',
        '\u8fbe\u5dde@@@399',
        '\u8fea\u5e86@@@660',
        '\u5fb7\u5b8f@@@657',
        '\u5927\u7406@@@427',
        '\u510b\u5dde@@@3199',
    ],
    E: [
        '\u9102\u5c14\u591a\u65af@@@617',
        '\u9102\u5dde@@@298',
        '\u6069\u65bd@@@323',
    ],
    F: [
        '\u4f5b\u5c71@@@357',
        '\u798f\u5dde@@@198',
        '\u961c\u65b0@@@72',
        '\u629a\u987a@@@66',
        '\u629a\u5dde@@@669',
        '\u961c\u9633@@@582',
        '\u9632\u57ce\u6e2f@@@372',
    ],
    G: [
        '\u5e7f\u5dde@@@347',
        '\u7518\u5357\u85cf\u65cf\u81ea\u6cbb\u5dde@@@640',
        '\u56fa\u539f@@@643',
        '\u7518\u5b5c@@@650',
        '\u5e7f\u5b89@@@398',
        '\u5e7f\u5143@@@393',
        '\u679c\u6d1b\u85cf\u65cf\u81ea\u6cbb\u5dde@@@689',
        '\u8d63\u5dde@@@215',
        '\u8d35\u9633@@@414',
        '\u8d35\u6e2f@@@374',
        '\u6842\u6797@@@369',
    ],
    H: [
        '\u83cf\u6cfd@@@680',
        '\u6cb3\u6e90@@@675',
        '\u60e0\u5dde@@@352',
        '\u90af\u90f8@@@8',
        '\u8861\u6c34@@@16',
        '\u9e64\u58c1@@@265',
        '\u54c8\u5c14\u6ee8@@@102',
        '\u9ed1\u6cb3@@@112',
        '\u9e64\u5c97@@@107',
        '\u846b\u82a6\u5c9b@@@70',
        '\u547c\u548c\u6d69\u7279@@@48',
        '\u547c\u4f26\u8d1d\u5c14@@@627',
        '\u548c\u7530@@@471',
        '\u54c8\u5bc6@@@467',
        '\u6c49\u4e2d@@@439',
        '\u9ec4\u5357@@@686',
        '\u6d77\u897f@@@820',
        '\u6d77\u5317@@@685',
        '\u6d77\u5357@@@683',
        '\u6d77\u4e1c@@@687',
        '\u8861\u9633@@@329',
        '\u6000\u5316@@@337',
        '\u9ec4\u77f3@@@292',
        '\u9ec4\u5188@@@300',
        '\u5408\u80a5@@@181',
        '\u6dee\u5317@@@183',
        '\u6dee\u5357@@@182',
        '\u9ec4\u5c71@@@189',
        '\u6dee\u5b89@@@140',
        '\u676d\u5dde@@@153',
        '\u6e56\u5dde@@@157',
        '\u7ea2\u6cb3\u5dde@@@656',
        '\u6cb3\u6c60@@@378',
        '\u8d3a\u5dde@@@671',
        '\u6d77\u53e3@@@380',
    ],
    J: [
        '\u6d4e\u5357@@@225',
        '\u6d4e\u5b81@@@232',
        '\u63ed\u9633@@@676',
        '\u6c5f\u95e8@@@356',
        '\u7126\u4f5c@@@264',
        '\u6d4e\u6e90@@@279',
        '\u4f73\u6728\u65af@@@109',
        '\u9e21\u897f@@@104',
        '\u5409\u6797@@@86',
        '\u9526\u5dde@@@69',
        '\u9152\u6cc9@@@454',
        '\u91d1\u660c@@@447',
        '\u5609\u5cea\u5173@@@446',
        '\u664b\u57ce@@@37',
        '\u664b\u4e2d@@@569',
        '\u8346\u5dde@@@295',
        '\u8346\u95e8@@@297',
        '\u4e5d\u6c5f@@@212',
        '\u666f\u5fb7\u9547@@@210',
        '\u5409\u5b89@@@219',
        '\u5609\u5174@@@156',
        '\u91d1\u534e@@@159',
    ],
    K: [
        '\u5f00\u5c01@@@261',
        '\u5580\u4ec0@@@811',
        '\u514b\u62c9\u739b\u4f9d@@@463',
        '\u5e93\u5c14\u52d2@@@3196',
        '\u6606\u660e@@@420',
    ],
    L: [
        '\u4e34\u6c82@@@568',
        '\u804a\u57ce@@@237',
        '\u83b1\u829c@@@236',
        '\u9f99\u5ca9@@@589',
        '\u5eca\u574a@@@15',
        '\u6d1b\u9633@@@262',
        '\u6f2f\u6cb3@@@270',
        '\u8fbd\u6e90@@@88',
        '\u8fbd\u9633@@@73',
        '\u5170\u5dde@@@445',
        '\u4e34\u590f@@@451',
        '\u9647\u5357@@@816',
        '\u4e34\u6c7e@@@40',
        '\u5415\u6881@@@622',
        '\u6797\u829d@@@1028',
        '\u62c9\u8428@@@432',
        '\u4e50\u5c71@@@395',
        '\u51c9\u5c71@@@649',
        '\u6cf8\u5dde@@@390',
        '\u5a04\u5e95@@@338',
        '\u516d\u5b89@@@193',
        '\u8fde\u4e91\u6e2f@@@125',
        '\u4e3d\u6c34@@@174',
        '\u4e3d\u6c5f@@@659',
        '\u4e34\u6ca7@@@658',
        '\u516d\u76d8\u6c34@@@415',
        '\u6765\u5bbe@@@541',
        '\u67f3\u5dde@@@368',
    ],
    M: [
        '\u6885\u5dde@@@584',
        '\u8302\u540d@@@360',
        '\u7261\u4e39\u6c5f@@@110',
        '\u7ef5\u9633@@@391',
        '\u7709\u5c71@@@652',
        '\u9a6c\u978d\u5c71@@@187',
    ],
    N: [
        '\u5b81\u5fb7@@@207',
        '\u5357\u5e73@@@204',
        '\u5357\u9633@@@272',
        '\u90a3\u66f2@@@971',
        '\u5357\u5145@@@396',
        '\u5185\u6c5f@@@392',
        '\u5357\u660c@@@209',
        '\u5357\u4eac@@@123',
        '\u5357\u901a@@@129',
        '\u5b81\u6ce2@@@154',
        '\u6012\u6c5f@@@661',
        '\u5357\u5b81@@@367',
    ],
    P: [
        '\u8386\u7530@@@201',
        '\u6fee\u9633@@@268',
        '\u5e73\u9876\u5c71@@@263',
        '\u76d8\u9526@@@76',
        '\u5e73\u51c9@@@450',
        '\u6500\u679d\u82b1@@@388',
        '\u840d\u4e61@@@211',
        '\u666e\u6d31@@@625',
    ],
    Q: [
        '\u9752\u5c9b@@@226',
        '\u6e05\u8fdc@@@628',
        '\u6cc9\u5dde@@@202',
        '\u79e6\u7687\u5c9b@@@13',
        '\u9f50\u9f50\u54c8\u5c14@@@103',
        '\u4e03\u53f0\u6cb3@@@111',
        '\u5e86\u9633@@@638',
        '\u6f5c\u6c5f@@@318',
        '\u8862\u5dde@@@160',
        '\u66f2\u9756@@@421',
        '\u9ed4\u897f\u5357@@@969',
        '\u9ed4\u4e1c\u5357@@@666',
        '\u9ed4\u5357@@@662',
        '\u94a6\u5dde@@@373',
        '\u743c\u6d77@@@3331',
    ],
    R: ['\u65e5\u7167@@@235', '\u65e5\u5580\u5219@@@974'],
    S: [
        '\u4e0a\u6d77@@@611',
        '\u6df1\u5733@@@348',
        '\u6c55\u5c3e@@@353',
        '\u97f6\u5173@@@351',
        '\u6c55\u5934@@@350',
        '\u4e09\u660e@@@200',
        '\u77f3\u5bb6\u5e84@@@6',
        '\u5546\u4e18@@@273',
        '\u4e09\u95e8\u5ce1@@@271',
        '\u53cc\u9e2d\u5c71@@@106',
        '\u7ee5\u5316@@@113',
        '\u56db\u5e73@@@87',
        '\u677e\u539f@@@91',
        '\u6c88\u9633@@@63',
        '\u77f3\u6cb3\u5b50@@@3195',
        '\u77f3\u5634\u5c71@@@460',
        '\u6714\u5dde@@@38',
        '\u5546\u6d1b@@@441',
        '\u5c71\u5357@@@972',
        '\u9042\u5b81@@@394',
        '\u90b5\u9633@@@330',
        '\u5341\u5830@@@293',
        '\u968f\u5dde@@@302',
        '\u4e0a\u9976@@@216',
        '\u5bbf\u5dde@@@191',
        '\u82cf\u5dde@@@133',
        '\u5bbf\u8fc1@@@624',
        '\u7ecd\u5174@@@158',
        '\u4e09\u4e9a@@@381',
        '\u4e09\u6c99@@@3200',
    ],
    T: [
        '\u5929\u6d25@@@615',
        '\u6cf0\u5b89@@@233',
        '\u5510\u5c71@@@7',
        '\u901a\u5316@@@89',
        '\u94c1\u5cad@@@74',
        '\u901a\u8fbd@@@540',
        '\u5854\u57ce\u5730\u533a@@@808',
        '\u5410\u9c81\u756a@@@472',
        '\u5929\u6c34@@@449',
        '\u592a\u539f@@@33',
        '\u94dc\u5ddd@@@436',
        '\u5929\u95e8@@@312',
        '\u94dc\u9675@@@185',
        '\u6cf0\u5dde@@@585',
        '\u53f0\u5dde@@@179',
        '\u94dc\u4ec1@@@665',
    ],
    W: [
        '\u6f4d\u574a@@@230',
        '\u5a01\u6d77@@@234',
        '\u4e4c\u6d77@@@50',
        '\u4e4c\u5170\u5bdf\u5e03\u76df@@@633',
        '\u4e4c\u9c81\u6728\u9f50@@@462',
        '\u6b66\u5a01@@@452',
        '\u5434\u5fe0@@@642',
        '\u6e2d\u5357@@@437',
        '\u6b66\u6c49@@@291',
        '\u829c\u6e56@@@184',
        '\u65e0\u9521@@@132',
        '\u6e29\u5dde@@@155',
        '\u6587\u5c71@@@653',
        '\u68a7\u5dde@@@370',
    ],
    X: [
        '\u53a6\u95e8@@@199',
        '\u90a2\u53f0@@@9',
        '\u65b0\u4e61@@@266',
        '\u8bb8\u660c@@@269',
        '\u4fe1\u9633@@@274',
        '\u5174\u5b89\u76df@@@636',
        '\u9521\u6797\u90ed\u52d2\u76df@@@632',
        '\u65b0\u7586\u514b\u5dde@@@466',
        '\u5ffb\u5dde@@@43',
        '\u897f\u5b89@@@433',
        '\u54b8\u9633@@@435',
        '\u897f\u5b81@@@456',
        '\u6e58\u897f@@@799',
        '\u6e58\u6f6d@@@328',
        '\u8944\u9633@@@621',
        '\u54b8\u5b81@@@301',
        '\u5b5d\u611f@@@299',
        '\u4ed9\u6843@@@308',
        '\u65b0\u4f59@@@213',
        '\u5ba3\u57ce@@@678',
        '\u5f90\u5dde@@@124',
        '\u897f\u53cc\u7248\u7eb3@@@654',
    ],
    Y: [
        '\u70df\u53f0@@@231',
        '\u4e91\u6d6e@@@673',
        '\u9633\u6c5f@@@358',
        '\u4f0a\u6625@@@108',
        '\u5ef6\u8fb9@@@631',
        '\u8425\u53e3@@@71',
        '\u4f0a\u7281@@@644',
        '\u94f6\u5ddd@@@459',
        '\u8fd0\u57ce@@@637',
        '\u9633\u6cc9@@@35',
        '\u6986\u6797@@@440',
        '\u5ef6\u5b89@@@438',
        '\u5b9c\u5bbe@@@397',
        '\u96c5\u5b89@@@402',
        '\u7389\u6811@@@688',
        '\u5cb3\u9633@@@331',
        '\u76ca\u9633@@@335',
        '\u6c38\u5dde@@@336',
        '\u5b9c\u660c@@@294',
        '\u5b9c\u6625@@@217',
        '\u9e70\u6f6d@@@214',
        '\u626c\u5dde@@@128',
        '\u76d0\u57ce@@@127',
        '\u7389\u6eaa@@@422',
        '\u7389\u6797@@@375',
    ],
    Z: [
        '\u6dc4\u535a@@@227',
        '\u67a3\u5e84@@@228',
        '\u8087\u5e86@@@514',
        '\u6e5b\u6c5f@@@359',
        '\u4e2d\u5c71@@@355',
        '\u73e0\u6d77@@@349',
        '\u6f33\u5dde@@@203',
        '\u5f20\u5bb6\u53e3@@@11',
        '\u90d1\u5dde@@@260',
        '\u5468\u53e3@@@275',
        '\u9a7b\u9a6c\u5e97@@@276',
        '\u5f20\u6396@@@453',
        '\u4e2d\u536b@@@641',
        '\u8d44\u9633@@@409',
        '\u81ea\u8d21@@@387',
        '\u682a\u6d32@@@327',
        '\u5f20\u5bb6\u754c@@@333',
        '\u9547\u6c5f@@@130',
        '\u821f\u5c71@@@161',
        '\u662d\u901a@@@423',
        '\u9075\u4e49@@@416',
    ],
};
var CityPop = function (props) {
    var _a = __read(useState('热门城市'), 2), selectedLetter = _a[0], setSelectedLetter = _a[1];
    var _b = __read(useState(null), 2), cityData = _b[0], setCityData = _b[1];
    var _c = __read(useState(function () {
        if (props.selected) {
            return props.selected;
        }
        return '';
    }), 2), selectedCid = _c[0], setSelectedCid = _c[1];
    useEffect(function () {
        smartScrollObj.cityPop = new smartScroll('#cityPop', 'cityPopCon');
    }, []);
    useEffect(function () {
        if (props.ajaxUrl && props.show && !cityData) {
            // 请求城市数据
            getData();
        }
        else if (!props.ajaxUrl && !cityData) {
            setCityData(cityListData);
        }
        if (props.show) {
            // 允许滚动
            smartScrollObj.cityPop.preventScroll();
        }
        else {
            smartScrollObj.cityPop.allowScroll();
        }
    }, [props]);
    useEffect(function () {
        if (cityData) {
            if (!Array.isArray(cityData['热门城市']) ||
                (Array.isArray(cityData['热门城市']) &&
                    cityData['热门城市'].length == 0)) {
                // 热门城市没有数据，将其他字母开头的数据预先显示
                var initKey = '';
                for (var i = 0; i < Object.keys(cityData).length; i++) {
                    if (Object.keys(cityData)[i] != '热门城市') {
                        initKey = Object.keys(cityData)[i];
                        break;
                    }
                }
                setSelectedLetter(initKey);
            }
        }
    }, [cityData]);
    var getData = useCallback(function () {
        // 获取数据
        var ajaxUrl = props.ajaxUrl, saveKey = props.saveKey;
        getStorageData(saveKey).then(function (data) {
            setCityData(data);
        }, function (error) {
            // 本地没有数据 异步获取数据
            ajaxUrl &&
                request(ajaxUrl, {}, 'jsonp')
                    .then(function (response) {
                    if (response.code == 0) {
                        var data = response.entity.data;
                        setStorageData({
                            key: saveKey,
                            value: data,
                            expire: 10,
                        });
                        setCityData(data);
                    }
                    else {
                        console.log(response.message);
                    }
                })
                    .catch(function (error) {
                    console.log(error);
                });
        });
    }, [props.ajaxUrl, props.saveKey]);
    var closePop = useCallback(function () {
        // 关闭弹窗
        if (props.closeFun) {
            props.closeFun();
        }
    }, []);
    var selectLetter = useCallback(function (e) {
        var key = e.target.getAttribute('data-key');
        if (key != selectedLetter) {
            setSelectedLetter(key);
        }
    }, [selectedLetter]);
    var selectedCity = useCallback(function (e) {
        var cid = e.target.getAttribute('data-cityid');
        var name = e.target.getAttribute('data-name');
        if (cid != selectedCid) {
            setSelectedCid(cid);
            props.callbackFun({ cid: cid, name: name });
        }
        else {
            props.closeFun();
        }
    }, [selectedCid, props]);
    return (React.createElement("div", { className: props.cn + " " + (props.show ? '' : 'hide') },
        React.createElement("div", { className: "newcar_ui_cityPopWrap", id: 'cityPop' },
            React.createElement("p", { className: 'newcar_ui_cityPopTitle' },
                React.createElement("b", null, "\u9009\u62E9\u57CE\u5E02"),
                React.createElement("a", { className: 'newcar_ui_cityPopCloseBtn', onClick: closePop })),
            React.createElement("section", { className: 'newcar_ui_cityPopCon', id: 'cityPopCon' },
                React.createElement("div", { className: 'newcar_ui_alphabetList' }, cityData &&
                    Object.keys(cityData).map(function (key) {
                        return key != '热门城市' ? (React.createElement("a", { key: "letter_" + key, className: key == selectedLetter ? 'cur' : '', "data-key": key, onClick: selectLetter }, key)) : ('');
                    })),
                React.createElement("div", { className: 'newcar_ui_citysListBox' },
                    React.createElement("div", { className: 'newcar_ui_cityListSheet' },
                        React.createElement("h3", { id: 'cityListTit' }, selectedLetter),
                        React.createElement("div", { className: 'newcar_ui_cityListWrap ', id: 'cityList' },
                            React.createElement("ul", { className: 'newcar_ui_cityList' }, cityData &&
                                cityData[selectedLetter] &&
                                cityData[selectedLetter].map(function (item) {
                                    var name = item.split('@@@')[0], cid = item.split('@@@')[1];
                                    return (React.createElement("li", { key: "city_" + cid },
                                        React.createElement("a", { className: cid == selectedCid ? 'cur' : '', "data-cityid": cid, "data-name": name, onClick: selectedCity }, name)));
                                })))))))));
};
CityPop.defaultProps = {
    cn: '',
    selected: '',
    show: false,
    ajaxUrl: '',
    saveKey: '',
    // eslint-disable-next-line no-empty-function
    closeFun: function () { },
    // eslint-disable-next-line no-empty-function
    callbackFun: function (obj) { },
};
export default WithErrorHandler(memo(CityPop));
